// Empire Jamaica Fusion — Gallery page data (authentic project images only)

const CA = "https://customer-assets.emergentagent.com/job_caribbean-premium/artifacts";
const B8 = "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts";
const PROD =
    "https://static.prod-images.emergentagent.com/jobs/c2b7593f-ae8f-4892-a9ba-b424e7885b58/images";

export const GALLERY_CATEGORIES = [
    { id: "all", label: "All" },
    { id: "food", label: "Food" },
    { id: "catering", label: "Catering" },
    { id: "private-events", label: "Private Events" },
    { id: "restaurant", label: "Restaurant" },
    { id: "behind-the-scenes", label: "Behind the Scenes" },
];

// Interleaved order for a dynamic "All" view
export const GALLERY_ITEMS = [
    {
        src: `${B8}/bwzczki2_6AED80A2-E5AD-4A8F-A910-849ACAE56061%202.PNG`,
        title: "Escovitch Fish",
        caption: "Signature Plates",
        category: "food",
    },
    {
        src: `${B8}/so154t3e_4D544B4D-5ED1-4118-B68A-2CABF55656D8%202.PNG`,
        title: "Floral Buffet Display",
        caption: "Catering Moments",
        category: "catering",
    },
    {
        src: `${CA}/2s6v3098_56BE41F0-CED7-4829-B4F0-293F7449CF20.PNG`,
        title: "In the Kitchen",
        caption: "From the Kitchen",
        category: "behind-the-scenes",
    },
    {
        src: `${B8}/dl060mcc_CE2C979B-83C4-417C-A61B-198E9E76761B.PNG`,
        title: "Michelle & Local Leaders",
        caption: "Community Partners",
        category: "behind-the-scenes",
    },
    {
        src: `${B8}/wfwhbttq_20E119FE-48F8-4837-A259-B87021DF969B.PNG`,
        title: "Braised Oxtail",
        caption: "Empire Favorites",
        category: "food",
    },
    {
        src: `${B8}/cgxmtqev_90DA897D-570F-4536-9634-1812C7F856DA.PNG`,
        title: "Ballroom Reception",
        caption: "Private Events",
        category: "private-events",
    },
    {
        src: `${CA}/268snciq_4B00982C-BDB8-4044-BB1B-7B7FE2243CA8.PNG`,
        title: "The Dining Room",
        caption: "Caribbean Hospitality",
        category: "restaurant",
    },
    {
        src: `${B8}/jqstmtoi_8297D13F-5615-4362-B284-285AC91D213A.PNG`,
        title: "Curry Chicken",
        caption: "Signature Plates",
        category: "food",
    },
    {
        src: `${B8}/akevgric_74098083-15F2-457E-8577-0FBE43FFCA51.PNG`,
        title: "Birthday Celebration",
        caption: "Catering Moments",
        category: "catering",
    },
    {
        src: `${B8}/vp3l83vv_69815085-246A-45C7-B581-5675DC197104.PNG`,
        title: "Rooftop at Sunset",
        caption: "Private Events",
        category: "private-events",
    },
    {
        src: `${B8}/zz8oh899_A99AA3D4-A647-4577-A454-4AACC94A37F1%202.PNG`,
        title: "Garlic Shrimp",
        caption: "Empire Favorites",
        category: "food",
    },
    {
        src: `${B8}/2j9ynage_Family_Gathering_event.PNG`,
        title: "Family Gathering",
        caption: "Catering Moments",
        category: "catering",
    },
    {
        src: `${CA}/uowmbhf2_24B584D4-D59C-4E4E-97AC-8CB525C35052.PNG`,
        title: "On Main Street",
        caption: "Caribbean Hospitality",
        category: "restaurant",
    },
    {
        src: `${B8}/w5hkekjx_E4A3D5A3-08FA-4657-BB26-72773561DDAE%202.PNG`,
        title: "Vegan Crab Cakes",
        caption: "Plant-Based Favorites",
        category: "food",
    },
    {
        src: `${B8}/tt3kmf0p_0FB7FE96-C940-4F9B-87DF-C29E988B00E6.PNG`,
        title: "Vibrant Event Spread",
        caption: "Catering Moments",
        category: "catering",
    },
    {
        src: `${B8}/3a3gg55y_4F31409C-D6F5-4DDA-9779-4F8F44844AA6.PNG`,
        title: "Private Dining",
        caption: "Private Events",
        category: "private-events",
    },
    {
        src: `${PROD}/ac8d89d2beb6f6181caed66430f6c32867fb9c236253afcb2b1cb0f8c9971530.png`,
        title: "Jerk Chicken",
        caption: "Signature Plates",
        category: "food",
    },
    {
        src: `${CA}/algcp3ha_04DCB600-D055-49ED-AC04-941FD249AA1D.PNG`,
        title: "Opening Day on Main Street",
        caption: "Caribbean Hospitality",
        category: "behind-the-scenes",
    },
];
